import type { RenderComponentProps } from "../../../shared/types";
import type { AccordionContextType } from "./context";

import * as React from "react";

import * as Accordion from "@radix-ui/react-accordion";

import { useRenderChildren } from "../../../shared/utils/renderComponents";
import useSharedState from "../../hooks/useSharedState";
import { getAccordionNewItems } from "../../utils/accordion";
import { ReploComponent } from "../ReploComponent";
import { AccordionContext } from "./context";

const AccordionBlock: React.FC<RenderComponentProps> = ({
  context,
  componentAttributes,
  component,
}) => {
  const children = useRenderChildren(component, { context });

  const { _autoClose } = component.props;
  const defaultOpenedChildCollapsibleId = children?.find((component) => {
    return (
      component.component.type === "collapsibleV2" &&
      component.component.props._defaultOpen === true
    );
  })?.component.id;

  const defaultAccordionOpenItemsValue = React.useMemo(() => {
    return defaultOpenedChildCollapsibleId
      ? [defaultOpenedChildCollapsibleId]
      : null;
  }, [defaultOpenedChildCollapsibleId]);

  const [accordionOpenItems, setAccordionOpenItems] = useSharedState(
    [component.id, `accordionOpenItems`],
    defaultAccordionOpenItemsValue,
  );

  const accordionContextValue: AccordionContextType = {
    openItems: accordionOpenItems ?? [],
    toggleItem: (componentId) => {
      const newAccordionOpenItems = getAccordionNewItems(
        componentId,
        accordionOpenItems ?? undefined,
        _autoClose,
      );
      setAccordionOpenItems(newAccordionOpenItems);
    },
  };

  return (
    <AccordionContext.Provider value={accordionContextValue}>
      <Accordion.Root asChild type="multiple" value={accordionOpenItems ?? []}>
        <div {...componentAttributes}>
          {children?.map(({ component, context }) => (
            <ReploComponent
              key={component.id}
              component={component}
              context={context}
            />
          ))}
        </div>
      </Accordion.Root>
    </AccordionContext.Provider>
  );
};

export default AccordionBlock;
